import * as React from 'react';


import Box from '@mui/material/Box'


import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Card from'@mui/material/Card'
import CardContent from'@mui/material/CardContent'
import CardHeader from'@mui/material/CardHeader'
import { CharismaStudentTrainingApi } from '../api/studentTrainings/CharismaStudentTrainingApi.tsx';
import CharismaAlertForm from './alertForm.tsx';
import { CharismaUserContext } from '../context.tsx';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit'
import {formatDate} from '../utils.tsx'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';




export default function CharismaAlertsList(props){
    
    interface trainingPeriod{
        id: number,
        name: string,
        startDate: string,
        endDate: string
    }    
    const [currentAlert, setCurrentAlert] = React.useState(null);
    const [create, setCreate] = React.useState(false);
    const [alertsList, setAlertsList] = React.useState([]);
    const [deleteAlerts, setDeleteAlerts] = React.useState(false);
    const [selectedAlerts, setSelectedAlerts] = React.useState([]);   
   
    const lCurrentUser = React.useContext(CharismaUserContext);
    const lReadWrite = lCurrentUser !== null && lCurrentUser !== undefined && (lCurrentUser.profile === 0 || lCurrentUser.profile === 2);
    const lStudentTrainingId = props.studentTrainingId;    


    React.useEffect(()=>{
        const lResponsePeriods = CharismaStudentTrainingApi.ListAlerts(lStudentTrainingId);
        lResponsePeriods.then((value)=>{
            if(value.error === 0){
                setAlertsList(value.alerts);
            }
        }).catch((error)=>{
            
        })
    }, [lStudentTrainingId])
    
    
          
    function handleCreateAlert(pSubject : string, pAlert : string){
        const lResponse = CharismaStudentTrainingApi.CreateAlert(pSubject, pAlert, lStudentTrainingId)
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.alert !== null){
                    let lAlerts = alertsList.concat(value.alert);
                    setAlertsList(lAlerts);
                    setCreate(false);
                }
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    } 
    function handleCancelCreate(){
        setCreate(false);
    }
                    
    function handleDeleteAlerts(){
        const lResponse = CharismaStudentTrainingApi.DeleteAlerts(selectedAlerts);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.ids !== null){
                    const lIds = value.ids;
                    let lAlerts = alertsList.filter((lAlert)=>lIds.indexOf(lAlert.id) === -1);
                    setAlertsList(lAlerts);
                    setDeleteAlerts(false);                  
                }
;            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })           
    }            
    
    function handleSelectedAlert(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lNewSelected : number[] = [];
        let lIndex = selectedAlerts.indexOf(pId);
        if(pEvent.target.checked && lIndex === -1){
            lNewSelected = lNewSelected.concat(selectedAlerts, pId);
        }
        else if(lIndex !== -1){
            if(lIndex === 0){
                lNewSelected = lNewSelected.concat(selectedAlerts.slice(1));
            }
            else if(lIndex === selectedAlerts.length - 1){
                lNewSelected = lNewSelected.concat(selectedAlerts.slice(0, -1));
            }
            else{
                lNewSelected = lNewSelected.concat(selectedAlerts.slice(0, lIndex), selectedAlerts.slice(lIndex + 1),);
            }
        }
        setSelectedAlerts(lNewSelected);
    }
            
    
    function handleCloseEdit(){
        setCurrentAlert(null);
    }
    
    function handleEdit(pId : number){
          for(let lIndex = 0; lIndex < alertsList.length; lIndex++){
              const lAlert = alertsList[lIndex];
              if(lAlert.id == pId){
                  setCurrentAlert(lAlert);
                  break;
              }
          } 
    }
    
    
    function createAlertsTable(pAlerts : trainingPeriod[], pSelected : number[]){
        return(
            pAlerts.map((alert)=>(
                <TableRow key={alert.id}>
                    {lReadWrite ?
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={pSelected.indexOf(alert.id) >= 0}
                                onClick={                                    
                                    (event)=>handleSelectedAlert(event, alert.id)
                                    }
                            />
                        </TableCell>
                        :
                        null
                    }
                    <TableCell>
                        {formatDate(alert.date)}
                    </TableCell>
                    <TableCell>
                        {alert.subject}
                    </TableCell>
                    <TableCell>
                        {alert.author}
                    </TableCell>
                    {lReadWrite  ?
                        <TableCell padding="checkbox">
                            <IconButton
                                onClick={()=>handleEdit(alert.id)}
                            >
                                <EditIcon/>
                            </IconButton>
                        </TableCell>
                        :
                        null
                    }
                </TableRow>
                 
            ))
        )
    }
    
    
    return(
        
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Card>
                        <CardHeader
                            title="Alertes"
                            action={
                                <div>
                                {lReadWrite?
                                <div>
                                <IconButton onClick={()=>setCreate(true)}>
                                    <AddIcon/>
                                </IconButton>
                                {selectedAlerts.length > 0?
                                    <IconButton onClick={()=>setDeleteAlerts(true)}>
                                        <DeleteIcon/>
                                    </IconButton>  
                                    :
                                    null
                                } 
                                </div>
                                :
                                null
                                }                                
                                </div>
                            }
                        />
                        <CardContent>
                            <Table>                               
                                <TableHead>
                                    <TableRow>
                                        {lReadWrite ?
                                            <TableCell padding="checkbox">
                                                </TableCell>
                                              :
                                              null
                                        }
                                        <TableCell>Date</TableCell>
                                        <TableCell>Objet</TableCell>
                                        <TableCell>Auteur</TableCell>
                                        <TableCell padding="checkbox">
                                        </TableCell>                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    createAlertsTable(alertsList, selectedAlerts)
                                }
                                </TableBody>
                            </Table>                            
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            {create ?
                <CharismaAlertForm
                    handleSubmit={handleCreateAlert}
                    handleCancel={handleCancelCreate}

                />
                :
                null    
            }    
            {
                currentAlert !== null ?
                <CharismaAlertForm
                    subject={currentAlert.subject}
                    alert={currentAlert.alert}
                    author={currentAlert.author}
                    date={currentAlert.date}
                    readOnly={true}
                    handleCancel={handleCloseEdit}

                />                
                :
                null
            }
            
            <Dialog
                open={deleteAlerts}
            >
                <DialogTitle>Suppression des alerts</DialogTitle>
                <DialogContent>
                    <Typography>Etes-vous sûr de vouloir supprimer définitivement les alerts sélectionnés?</Typography>
                    {
                        false?
                            <Alert severity='info'>Suppression en cours...</Alert>
                        :
                        null
                    }
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteAlerts(false)}>
                        Annuler
                    </Button>
                    <Button onClick={handleDeleteAlerts}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>                     
        </Box>      
    );
    
    
}